// Colour tokens map to Figma divergent/red-amber-green/1–5
export type RiskScoreColour =
    | 'divergent-red-amber-green-1'
    | 'divergent-red-amber-green-2'
    | 'divergent-red-amber-green-3'
    | 'divergent-red-amber-green-4'
    | 'divergent-red-amber-green-5';
export type RiskScoreDirection = 'higher-worse' | 'higher-better';
export type ScoreBand = 1 | 2 | 3 | 4 | 5;

const HIGHER_WORSE_BANDS: ReadonlyArray<{ threshold: number; band: ScoreBand }> = [
    { threshold: 0.8, band: 1 },
    { threshold: 0.6, band: 2 },
    { threshold: 0.4, band: 3 },
    { threshold: 0.2, band: 4 },
    { threshold: 0, band: 5 },
];

const HIGHER_BETTER_BANDS: ReadonlyArray<{ threshold: number; band: ScoreBand }> = [
    { threshold: 0.8, band: 5 },
    { threshold: 0.6, band: 4 },
    { threshold: 0.4, band: 3 },
    { threshold: 0.2, band: 2 },
    { threshold: 0, band: 1 },
];

export const riskScoreBand = (value: number, direction: RiskScoreDirection): ScoreBand => {
    const bands = direction === 'higher-worse' ? HIGHER_WORSE_BANDS : HIGHER_BETTER_BANDS;
    const clamped = Math.max(0, Math.min(1, value));
    return bands.find(b => clamped >= b.threshold)!.band;
};

const COLOUR_BY_BAND: Record<ScoreBand, RiskScoreColour> = {
    1: 'divergent-red-amber-green-1',
    2: 'divergent-red-amber-green-2',
    3: 'divergent-red-amber-green-3',
    4: 'divergent-red-amber-green-4',
    5: 'divergent-red-amber-green-5',
};

export const riskScoreColour = (value: number, direction: RiskScoreDirection): RiskScoreColour =>
    COLOUR_BY_BAND[riskScoreBand(value, direction)];
